import i18n from '@/i18n'

const roleOptions = [
  {
    name: i18n.t('teamModal.coowner'),
    value: 'co-owner'
  },
  {
    name: i18n.t('teamModal.admin'),
    value: 'admin'
  },
  {
    name: i18n.t('teamModal.contributor'),
    value: 'contributor'
  },
  {
    name: i18n.t('teamModal.viewer'),
    value: 'viewer'
  },
  {
    name: i18n.t('teamModal.anonAdmin'),
    value: 'anonAdmin'
  },
  {
    name: i18n.t('teamModal.anonContributor'),
    value: 'anonContributor'
  },
  {
    name: i18n.t('teamModal.anonViewer'),
    value: 'anonViewer'
  },
  {
    name: i18n.t('teamModal.anonCoordinator'),
    value: 'anonCoordinator'
  },
  {
    name: i18n.t('teamModal.resultsViewer'),
    value: 'resultsViewer'
  }
]

export default {
  data: function () {
    return {
      roleOptions
    }
  }
}
